export default function OfferLine() {
  return (
    <div
      className="axa-icon-icon-offer-line"
      dangerouslySetInnerHTML={{
        __html: `
          <svg xmlns="http://www.w3.org/2000/svg" width="99" height="15.732" viewBox="0 0 99 15.732">
            <path id="Fill_1_Copy" data-name="Fill 1 Copy" d="M85.771,4.518A3.749,3.749,0,0,0,81.9,0q-15.992.2-31.923,1.56Q33.788,2.617,17.639,4.213a4.235,4.235,0,0,0-3.151,1.766Q8.7,6.934,2.929,8.031C-2.2,9.013-.029,16.624,5.09,15.645q10.52-2.015,21.121-3.5l68.863.308c5.232.023,5.238-7.872,0-7.9Z" transform="translate(0)" fill="#fff"/>
          </svg>
        `,
      }}
    />
  )
}
